import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";
import { chartColors } from "../constants";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

function ChartProductPlatform({ data }) {
    const { t } = useTranslation();
    const [groupedLineChartData, setGroupedLineChartData] = useState(null);
    const [groupedLineChartOptions, setGroupedLineChartOptions] = useState(null);

    useEffect(() => {
        if (!data?.length) return setGroupedLineChartData(null);

        const dates = [...new Set(data.map((d) => d._id))];

        const domainSet = new Set();
        data.forEach((item) => {
            item.domains.forEach((d) => {
                domainSet.add(d.domain ?? "Cotik");
            });
        });
        const allDomains = Array.from(domainSet);

        const datasets = allDomains.map((domain, index) => ({
            label: domain,
            data: Array(dates.length).fill(0),
            borderColor: chartColors[index % chartColors.length],
            backgroundColor: chartColors[index % chartColors.length],
            fill: false,
            tension: 0.4,
            pointRadius: 3,
        }));

        data.forEach((item, dateIndex) => {
            item.domains.forEach((domainItem) => {
                const domain = domainItem.domain ?? "Cotik";
                const datasetIndex = allDomains.indexOf(domain);
                datasets[datasetIndex].data[dateIndex] = domainItem.total;
            });
        });

        setGroupedLineChartData({
            labels: dates,
            datasets,
        });

        setGroupedLineChartOptions({
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        pointStyle: "circle",
                        boxWidth: 10,
                        boxHeight: 10,
                    },
                },
                tooltip: {
                    mode: "index",
                    intersect: false,
                    itemSort: (a, b) => b.raw - a.raw,
                    filter: (tooltipItem) => tooltipItem.raw !== null && tooltipItem.raw !== undefined && tooltipItem.raw !== 0,
                },
                datalabels: { display: false },
                title: {
                    display: true,
                    text: `${t("Product")}`,
                },
            },
        });
    }, [data, t]);

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ maxHeight: "700px" }}>
            {groupedLineChartData && groupedLineChartOptions ? (
                <Line data={groupedLineChartData} options={groupedLineChartOptions} />
            ) : (
                "No data available"
            )}
        </div>
    );
}

export default ChartProductPlatform;
